<template>
    <div class="missionBox">
        <div class="mission focus width grid grid-4">
            <a class="button-item" @click.prevent="$router.push('/healthy-step')">
                <div class="logo-block">
                    <img src="@/assets/icon/uide/Frame1198.svg" />
                </div>
                <div class="fM">健康計步</div>
            </a>
            <a class="button-item" @click.prevent="$router.push('/digital-card')">
                <div class="logo-block">
                    <img src="@/assets/icon/uide/digital-card-icon.svg" />
                </div>
                <div class="fM">數位圖書證</div>
            </a>
            <a class="button-item" @click.prevent="linkClickHandler(urls.yunlinHealthWalk)">
                <div class="logo-block">
                    <img src="@/assets/icon/uide/Frame1212.svg" />
                </div>
                <div class="fM">雲林健康步道</div>
            </a>
            <a class="button-item" @click.prevent="$router.push('/ecotableware')">
                <div class="logo-block">
                    <img src="@/assets/icon/uide/Frame1201.svg" />
                </div>
                <div class="fM">環保餐具租借與任務</div>
            </a>
        </div>
        <section id="popLeave" class="popup">
            <div class="popBody">
                <a class="close" @click.prevent="closeLeaveModal">
                    <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
                </a>
                <section class="popHeader">
                <!-- <span class="fL">Title</span> -->
                </section>
                <section class="popMain">
                    <div class="fL text-center">提示</div>
                    <div class="icon"></div>
                    <span class="">您即將離開 App 前往外部連結，請問是否繼續？</span>
                </section>
                <section class="popFooter flex">
                    <a
                        class="button bg-transparent text-black border border-primary flex-1 submit rounded"
                        @click.prevent="closeLeaveModal"
                        >返回</a
                    >
                    <a class="button flex-1 submit rounded" @click.prevent="goOut()"
                        ><span class="fM">確認</span></a
                    >
                </section>
            </div>
        </section>
    </div>

</template>
<script>
import urls from "@/mixins/urls.js";

export default{
    mixins: [urls],
    mounted() {
        this.uploadSteps();
    },
    methods:{
        uploadSteps() {
            const payload = {
                type: "upload_steps",
            };
            window.Yunlin?.postMessage(JSON.stringify(payload));
            window.flutter_inappwebview?.callHandler('Yunlin', JSON.stringify(payload));
            console.log("JS Interface", payload);
        },
        linkClickHandler(url) {
            this.openLeaveModal();
            this.nextUrl = url;
        },
        openLeaveModal() {
            const wrap = document.querySelector("#popLeave");
            wrap.style.display = "flex";
        },
        closeLeaveModal() {
            const wrap = document.querySelector("#popLeave");
            wrap.style.display = "none";
        },
        goOut() {
            this.closeLeaveModal();
            window.open(this.nextUrl, "_blank", "noopener,noreferrer");
        },
    }
}
</script>
<style lang="scss" scoped>
.missionBox {
    width: 100%;
}

.body .index .mission {
    background-color: #ece5ff;

    .button-item {
        display: block;
    }

    .logo-block{
        width: 100%;
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    .fM {
        height: fit-content;
        padding:0 3px;
        text-align: center;
    }
}

</style>